import { Component } from '@angular/core';
import { GeneralService } from '../../Services/generalservice.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent {
    LoginDetails: any;   // company login
    UserDetails: any;    // seeker login
    HomeUrl: any;
    isCompanyLogin: boolean = false;
    isSeekerLogin: boolean = false;

    constructor(
        public generalservice: GeneralService,
        private http: HttpClient,
        private router: Router
    ) {
        // get company login details
        this.LoginDetails = JSON.parse(localStorage.getItem("LoginDetails") || 'null');

        // get seeker login details
        this.UserDetails = JSON.parse(localStorage.getItem("userDetails") || 'null');

        // decide login type
        if (this.LoginDetails) {
            this.isCompanyLogin = true;
        } else if (this.UserDetails) {
            this.isSeekerLogin = true;
        }

        this.http.get('../assets/WebService.json').subscribe((data: any) => {
            this.HomeUrl = data.Webservice;
        });
    }
    ngOnInit(): void { }
    Logout() {
        localStorage.clear();
        this.router.navigate(['']).then(() => {
            window.location.reload();
        });
    }
}
